import React, { useCallback, useState } from 'react';
import { ConfirmChangesDialog } from '../components/organisms/NavigationBlocker';

// Hook for imperatively opening a confirmation dialog with translated title/text and a callback
// to run on accept. Returns `{ confirm, dialog }`: render `dialog` anywhere in the tree and call
// `confirm({ titleKey, textKey, onConfirm })` to open it.
export default function useConfirmDialog() {
    const [state, setState] = useState(null);

    const confirm = useCallback(({ titleKey, textKey, body, onConfirm, onCancel }) => {
        setState({ titleKey, textKey, body, onConfirm, onCancel });
    }, []);

    // Defer the callback to a microtask so that if it opens another dialog via `confirm(...)`,
    // its setState wins over our closing setState(null) and the new dialog renders correctly.
    const handleAccept = useCallback(() => {
        const onConfirm = state?.onConfirm;
        setState(null);
        if (onConfirm) queueMicrotask(onConfirm);
    }, [state]);

    const handleReject = useCallback(() => {
        const onCancel = state?.onCancel;
        setState(null);
        if (onCancel) queueMicrotask(onCancel);
    }, [state]);

    const dialog = (
        <ConfirmChangesDialog
            open={!!state}
            title={state?.titleKey || ''}
            text={state?.textKey || ''}
            body={state?.body || null}
            acceptText="STATIC.BUTTONS.CONFIRM"
            rejectText="STATIC.BUTTONS.CANCEL"
            onAccept={handleAccept}
            onReject={handleReject}
        />
    );

    return { confirm, dialog };
}
